(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.referencesParagraph = {
    attach: function (context, settings) {
      var referencesOpenButton = $('.references-open-button', context);
      if (referencesOpenButton.length === 0) return;

      referencesOpenButton.on('click', function() {
        $(this).toggleClass('active');
        $(this).siblings('.field--name-field-description').toggleClass('active');
      });

      $('.references-hide-button').on('click', function() {
        referencesOpenButton.toggleClass('active');
        referencesOpenButton.siblings('.field--name-field-description').toggleClass('active');
      })
    }
  };

})(jQuery, Drupal);
